import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from '../WebApiService';
import { CryptoController } from './CryptoController';
import { OreController } from './OreController';
import { PlansController } from './PlansController';
import { BoletoItauController } from './BoletoItauController';
import { CieloController } from './CieloController';
import { TasksController } from './TasksController';
import { FiltersController } from './FiltersController';

@Injectable()
export class ControllersService {
  
  getFilters() {
    return new FiltersController(this._http,this._webApi);
  }


  getCrypto(): CryptoController {
    return new CryptoController(this._http,this._webApi);
  }
  constructor(public _http: HttpClient,private _webApi:WebApiService) {

  }

  getCielo(): CieloController {

    return new CieloController(this._http,this._webApi);
  }

  getBoletoItau(): BoletoItauController {

    return new BoletoItauController(this._http,this._webApi);
  }

  getPlans(): PlansController {
    return new PlansController(this._http,this._webApi

    );
  }

  getOre(): OreController {
    return new OreController(this._http,this._webApi);
  }

  getTasks(): TasksController {
    return new TasksController(this._http,this._webApi);
  }

}



